module.exports = __webpack_public_path__ + "static/img/item9@2x.9a005eae.png";